import { render, staticRenderFns } from "./MyAcademy.vue?vue&type=template&id=b446a040&scoped=true&"
import script from "./MyAcademy.vue?vue&type=script&lang=js&"
export * from "./MyAcademy.vue?vue&type=script&lang=js&"
import style0 from "./MyAcademy.vue?vue&type=style&index=0&id=b446a040&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b446a040",
  null
  
)

export default component.exports